import { useEffect, useRef, useState } from "react";
import { DownCaret } from "../Icons/Carets";
import { SearchIcon } from "../SelectDropdown";
import XIcon from "vagaro-website-rendering/src/components/Icons/XIcon";





export type CheckCategory = {

    name: string,
    id: string
    items: { name: string, checked: boolean, id: string, saveID?: string }[]
    isCollapsed?: boolean

}

export enum CategoryFilterStatus {
    None = 0,
    All = 1,
    Some = 2

}

export type CategoryFilterData = {
    included: string[];
    id: string;
    status: number;

}

export type ClassCategoryFilterData = {
    included: string[];
    excluded: string[];
}





export function MultilocationCategorySelector({toolTipId, catagories, forceSelected, onUpdate, useAmbiguous, includeIds,showFilter }: {toolTipId:string, catagories: CheckCategory[], forceSelected: string[], onUpdate: (cats: CheckCategory[]) => void, useAmbiguous?: boolean, includeIds?: boolean,showFilter?:boolean }) {

    const [toggleState, setToggleState] = useState(false);

    const onUpdateSelections = () => {
        onUpdate(catagories);
    }

    const setAll = (checked: boolean) => {

        for (let i = 0; i < catagories.length; i++) {
            for (let j = 0; j < catagories[i].items.length; j++) {
                if (forceSelected.includes(catagories[i].items[j].id)) {
                    catagories[i].items[j].checked = true;
                }
                else {
                    catagories[i].items[j].checked = checked;
                }
            }
        }

        onUpdateSelections();
        setToggleState(!toggleState);

    }



    function RenderCategoryBox({ category, filter, onUpdateSelections }: { category: CheckCategory, filter?: string, onUpdateSelections?: () => void }) {


        let filterList = filter?.split(" ")??[""];


        const [toggleState, setToggleState] = useState(false);
        const checkOrUncheckAll = () => {

            let allChecked = true;
            for (let i = 0; i < category.items.length; i++) {
                if (!category.items[i].checked) {
                    allChecked = false;
                    break;
                }
            }

            for (let i = 0; i < category.items.length; i++) {
                category.items[i].checked = !allChecked;
            }


            setToggleState(!toggleState);
            onUpdateSelections && onUpdateSelections();
        }

        const getCategoryState = () => {
            let checkedCount = 0;

            for (let i = 0; i < category.items.length; i++) {
                if (category.items[i].checked) {
                    checkedCount++;
                }
            }

            if (checkedCount == 0) {
                return 0;
            }
            else if (checkedCount == category.items.length) {
                return 1;
            }
            else {
                if (useAmbiguous)
                    return 2;
                else
                    return 1;
            }
        }

        let found = true;
  

        if (filter) {
            found = false;

            for(let f = 0;f<filterList.length;f++){
                if (category.name.toLowerCase().includes(filterList[f].toLowerCase())) {
                    found = true;
                   
                }
                else{
                    found = false;
                    break;
                }
            }
        

            if(!found) {    
                for (let i = 0; i < category.items.length; i++) {
               
                    for(let f = 0;f<filterList.length;f++){
                        if (category.items[i].name.toLowerCase().includes(filterList[f].toLowerCase())) {
                            found = true;                    
                        }
                        else{
                            found = false;
                            break;
                        
                        }
                    }
                    if (found)
                        break;
                }
            }

        }

        if (!found) {
            return <></>;
        }


        return <><div className="flex-row gap-small ellipsis" style={{ height: "44px",marginBottom:"2px" }}>
            <div
                style={{ cursor: "pointer", padding: "4px", fontSize: "12px", transform: (category.isCollapsed ? "rotate(-90deg)" : "rotate(0deg)"), transition: "transform .2s " }}
                onClick={() => { category.isCollapsed = !category.isCollapsed; setToggleState(!toggleState) }}
            ><DownCaret /></div>
            <div className="flex-row gap-med cursor-pointer" style={{ paddingLeft: "4px" }} onClick={checkOrUncheckAll}>
                <AmbiguousCheckSelect checkState={getCategoryState()} />
                <span className="max-100 ellipsis" style={{ maxWidth: "300pxx" }}>{category.name}</span></div>
        </div>

            {!category.isCollapsed  && <div className="flex-column " style={{ paddingLeft: "46px" }} >


                {category.items.map((item, i) => {

                    if(item.name=="")
                        return null;

                    let found = true;

                    if(filter){
                    for(let f = 0;f<filterList.length;f++){
                        if (category.name.toLowerCase().includes(filterList[f].toLowerCase())) {
                            found = true;
                        
                        }
                        else{
                            found = false;
                            break;
                        }
                    }

                    if (!found) {
                        found = false;

                        for(let f = 0;f<filterList.length;f++){
                            if (item.name.toLowerCase().includes(filterList[f].toLowerCase())) {
                                found = true;
                            
                            }
                            else{
                                found = false;
                                break;
                            }
                        }

                    }
                }
                    if (!found) {
                        return null;
                    }


                    return <CheckItem key={i} item={item.name} checked={item.checked} tooltip={ (item.id==toolTipId?"This business activated MySite and cannot be deselected.":"")}
                        inId={"check-" + item.id}
                        onClickFunc={() => { item.checked = !item.checked; setToggleState(!toggleState); onUpdateSelections && onUpdateSelections() }}
                    />
                })}

            </div>
            }
        </>
    }


    const [filter, setFilter] = useState("");


    return <div className="h-full" style={{ margin: "0px 0px 0px 0px" }} >
        <div className="h-full">
            <div className="flex-column gap-med w-full" style={{background:"white"}}>
                    <p>
                        Allow booking at more than 1 location on your MySite by selecting more locations.
                    </p>
                <div>
                    <button className="invisible-button" onClick={(e) => { e.preventDefault(); setAll(true) }}>Select All</button>
                    <button className="invisible-button" onClick={(e) => { e.preventDefault(); setAll(false) }}>Select None</button>
                </div>
                {showFilter && 
                 <div className="select-filter-input w-full" >
                     <input type="text" autoComplete="off" id="select-filter-search" className="w-full"  placeholder="Search" style={{padding:"8px 8px 8px 32px",borderRadius:"3px"}}
                  onInput={(e)=>{setFilter(e.currentTarget.value);}}
                  
                  ></input>
                  <div style={{position:"absolute",left:"4px",top:"1px",color:"#868686"}}>
                    <SearchIcon/>
                  </div>
                  {filter.length>0&&<div style={{position:"absolute",right:"8px",top:"18px",color:"#868686",cursor:"pointer"}} onClick={()=>{
                    setFilter("");
                    let inpt = document.getElementById("select-filter-search");
                    if(inpt)
                        (inpt as HTMLInputElement).value = "";

                  }}> <XIcon/> </div>      

                  }
                  </div> }
            </div>
            <div className="flex-column check-selector" style={{ fontWeight: "normal", padding: "0px 14px",height:"55vh" }}>

                {catagories.map((category, i) => {
                    return <RenderCategoryBox key={i} category={category} filter={filter} onUpdateSelections={onUpdateSelections} />
                })}
            </div>
        </div>
    </div>
}


export function CheckItem({ item, checked, onClickFunc, styling, inId,tooltip }: { inId?: string, item: string,tooltip?:string, checked: boolean, onClickFunc: (e: any) => void, styling?: any }) {

    const style = styling ?? { height: "44px" };

    return <div id={inId ?? ""} className="flex-row gap-med cursor-pointer relative check-hover" style={style} onClick={onClickFunc}>
        <AmbiguousCheckSelect checkState={(checked ? 1 : 0)} />
        <span className="max-100 ellipsis">{item}</span>
        {tooltip&&<ToolTip text={tooltip}/>}
    </div>
}
export function AmbiguousCheckSelect({ checkState }: { checkState: CategoryFilterStatus }) {


    return <div style={{ cursor: "pointer", width: "18px", height: "18px", border: "1px solid #CDCDCD", flexShrink: "0", borderRadius: "5px", background: (checkState == 0 ? "white" : "#333") }} className='center-all'>
        {
            checkState == CategoryFilterStatus.All && <svg xmlns="http://www.w3.org/2000/svg" height=".8em" viewBox="0 0 448 512" fill="white"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" /></svg>
        }
        {
            checkState == CategoryFilterStatus.Some && <svg xmlns="http://www.w3.org/2000/svg" height=".8em" fill="white" viewBox="0 0 448 512"><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z" /></svg>
        }

    </div>

}


function ToolTip({text}:{text:string}){

    const toolRef = useRef(null);
    const [flipped,setFlipped ] = useState(false);

    useEffect(()=>{


        if(toolRef.current){
            let parent = (toolRef.current as HTMLElement).parentElement;
            if(parent)
            parent.onmouseenter = ()=>{
                if(parent){
                let rect = parent.getBoundingClientRect();
                if(rect.bottom<window.innerHeight/2){
                    setFlipped(false);
                }
                else{
                    setFlipped(true);
                }
             }
            }
        }

    },[]);

    return <div ref={toolRef} className={"check-tooltip "+(flipped?"flipped":"")}>{text}</div>
}


